export enum EWorkshopsUrls {
  WORKSHOPS = 'workshops',
  CLASS = 'class',
  AGE_GROUP = 'age-group',
  CAPACITY = 'capacity',
  LANGUAGE = 'language',
  DATE_TIME = 'date-time',
  DATE = 'date',
  TIME = 'time',
  TIMEZONE = 'timezone',
  FACILITATOR = 'facilitator',
  CITIES = 'cities',
  LOCATION = 'location',
  LOCATION_ADDRESS = 'location-address',
  HOSTS = 'hosts',
  PLANNED_DATE = 'planned-date',
  HOSTED_PRIVATELY = 'hosted-privately',
  SHIPMENT_ADDRESS = 'shipment-address',
  SHIPMENT_LOCATION = 'shipment-location',
  SITE_COORDINATOR = 'site-coordinator',
  COORDINATOR = 'coordinator',
  FOOD_PROVIDED = 'food-provided',
  CHILDCARE_PROVIDED = 'childcare-provided',
  IDENTITY = 'identity',
  PHOTO = 'photo',
  GALLERY = 'gallery',
  PUBLISH = 'publish',
  REPUBLISH = 'republish',
  RESCHEDULE = 'reschedule',
  CANCEL = 'cancel',
  SESSION = 'session',
  SESSIONS = 'sessions',
  DESCRIPTION = 'description',
  URL = 'url',
  HOST = 'host',
  DUPLICATE = 'duplicate',
  MEETING_LINK = 'meeting-link',
  LOCATIONS = 'locations',
  CHILDCARE_COUNT = 'childcare-count',
  CHILDCARE = 'childcare',
  CUSTOM_QUESTION = 'custom-question',
  CLOSE = 'close',
  REGISTRANTS = 'registrants',
  PART = 'part',
  NOTES = 'notes',
  ORDERING = 'ordering',
  WORKSHOP_PART = 'workshop-part',
  KIT_ORDERS = 'kit-orders',
  REGISTRATION = 'registration',
}

export const editMeetingLinkUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.MEETING_LINK}`;
export const workshopLocationUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.LOCATIONS}`;
export const editSessionDateTimeUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.SESSION}/${EWorkshopsUrls.DATE_TIME}`;

export const editPartDateUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.PART}/${EWorkshopsUrls.DATE}`;
export const editPartTimeUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.PART}/${EWorkshopsUrls.TIME}`;

export const editWorkshopTimezoneUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.TIMEZONE}`;

export const workshopCustomQuestionUrl = `${EWorkshopsUrls.WORKSHOPS}/${EWorkshopsUrls.LOCATIONS}`;

export const workshopPartKitOrdersUrl = `${EWorkshopsUrls.ORDERING}/${EWorkshopsUrls.WORKSHOP_PART}/${EWorkshopsUrls.KIT_ORDERS}`;
